import React from 'react';
import axios from 'axios';

const KEY ="AIzaSyDV9e2nKzHFz9c0LsZ6YYI5H7QFCn_Nbwc";

const instance = axios.create({
  baseURL: "https://www.googleapis.com/youtube/v3",
  params: {
    part: "snippet",
    type:"video",
    maxResults: 5,
    order:'relevance',
    key: KEY
  }
});
export default instance
